export { FirebaseAnalytics } from '@capacitor-community/firebase-analytics';
